module.exports = __webpack_public_path__ + "static/media/iphone_12_mini_green.da35f5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_mini_green.png
// module id = 2084
// module chunks = 0